import { useDispatch } from 'react-redux';
import { systemActions } from '@/store/features';
import { ErrorDto } from '@/types/error.type';

export const useError = () => {
  const dispatch = useDispatch();
  const { pushError, clearErrors } = systemActions;
  return {
    push: (error: ErrorDto) => dispatch(pushError(error)),
    clear: () => dispatch(clearErrors()),
  };
};
